// TODO: refactor — replace NewMessageTypeModal with a new TypeScript component
import { MailingListItem } from '@/api/mailing-list/get-mailing-list'
import NewMessageTypeModal from '@/components/Organisation/CommunicationPortal/NewMessageTypeModal'
import { popupFactory } from '@/factories'
import { NewMessageFormModal } from '@/pages/communication/announcement-details/new-message-form-modal'
import { BuildingFilterItem } from '@/reducers/types'

import { LEGACY_TO_COMMUNICATION_TYPE } from './new-message-type-modal.constants'

interface AnnouncementsNewMessageTypeModalProps {
  onClose: VoidFunction
  communicateSMSAvailable: string | boolean | undefined
  shouldShowActivateSmsPanel: boolean
  mailingListOptions: Array<MailingListItem & { label: string }>
  selectedBuilding: BuildingFilterItem
  refreshTable: VoidFunction
  fetchAnnouncementDetails: VoidFunction
}

export const AnnouncementsNewMessageTypeModal = ({
  onClose,
  communicateSMSAvailable,
  shouldShowActivateSmsPanel,
  mailingListOptions,
  selectedBuilding,
  refreshTable,
  fetchAnnouncementDetails,
}: AnnouncementsNewMessageTypeModalProps) => {
  const handleTypeSubmit = (messageType: { value: string }) => {
    onClose()
    popupFactory.open(NewMessageFormModal, {
      fetchAnnouncementDetails,
      mailingListOptions,
      previewData: null,
      refreshTable,
      selectedBuilding,
      type: LEGACY_TO_COMMUNICATION_TYPE[messageType.value],
    })
  }

  return (
    <NewMessageTypeModal
      communicateSMSAvailable={communicateSMSAvailable}
      handleCancel={onClose}
      handleSubmit={handleTypeSubmit}
      shouldShowActivateSmsPanel={shouldShowActivateSmsPanel}
    />
  )
}
